// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './assets/css'
import Vue from 'vue'
import authentication from './util/authentication'
import {
    Dialog,
    DatePicker,
    Select,
    Option,
    OptionGroup,
    Popover,
    Tooltip,
    Loading,
} from 'element-ui';

Vue.use(Dialog);
Vue.use(DatePicker);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Loading.directive);
Vue.mixin(authentication);//权限方法混入
// import ElementUI from 'element-ui';
// Vue.use(ElementUI);

import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import menus from './layout/menus'

import store, {types as storeTypes} from './vuex'
import api from './api'
import './filters'

import VeeValidate, {Validator} from 'vee-validate';
import zh from 'vee-validate/dist/locale/zh_CN'

Validator.addLocale(zh);
var validateConfig = {
    locale: 'zh_CN',
    fieldsBagName: 'veefields'
};
Vue.use(VeeValidate, validateConfig);
import val from './assets/js/validator'

val.adapt();


import auth from './modules/account/auth'



Vue.config.productionTip = false;


Vue.prototype.$http = api.$http;
Vue.prototype.$base = api.base;

import layer from './assets/js/layer'

Vue.prototype.$layer = layer;

function go(to, next) {
    let hasPermission = true;
    let authCode = to.meta.authCode;
    if (authCode) {
        //路由需要权限
        hasPermission = authentication.methods.checkFeature(authCode, to.meta.forceCheckAuth)
    }
    if(hasPermission){
        next();
    }else{
        next({path: "/http/403"})
    }
}

router.beforeEach(async function (to, from, next) {
    store.commit(storeTypes.UPDATE_MASK, true);
    store.commit(storeTypes.SET_KEFU, to.path === "/kefu");
    //console.log("to", to);
    // 授权才能进入
    if (to.name != 'Login' && !store.state.COMMON) {
        var data = await api.base.initials();
        if (!data.user) {
            auth.authRequired({router: next, route: to})
        } else {
            //console.log("data.user", data.user);
            if(data.user.pwdIsEasy){
                store.commit(storeTypes.SET_PWD_STATUS, true);
            }
            go(to, next)
        }
    } else {
        go(to, next)
    }


});

router.afterEach(function (to) {
    store.commit(storeTypes.UPDATE_MASK, false);
    // 是否隐藏左侧菜单
    store.commit(storeTypes.SHOW_SLIDEBAR, !to.meta || to.meta.slidebar !== false);

    menus.routerChanged(to)
});

import directives from './directives'
directives.forEach(directive => {
    Vue.directive(directive.name, directive.directive)
});
window.Vue = Vue;

/* eslint-disable no-new */
window.app = new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js